import { render, staticRenderFns } from "./screen-menu-item.vue?vue&type=template&id=3ebc9d50"
import script from "./screen-menu-item.vue?vue&type=script&lang=ts"
export * from "./screen-menu-item.vue?vue&type=script&lang=ts"
import style0 from "./screen-menu-item.vue?vue&type=style&index=0&id=3ebc9d50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports